import { Component, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent implements AfterViewInit {
  constructor() {
  }

  title = 'app';
  ngAfterViewInit() {
      // console.warn('app component ng view init');
  }
}
